import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const Kontakt = () => (
  <>
    <SEOHead
      title="Kontakt – Leadership Focus GmbH München"
      description="Nehmen Sie Kontakt mit Leadership Focus auf. Wir beraten Sie gerne zu Coaching, Supervision, Qualifizierung und Organisationsberatung."
      canonical="https://leadership-focus.de/kontakt"
    />
    <Header />
    <main className="container py-20 min-h-[60vh]">
      <h1 className="text-4xl font-serif font-bold text-foreground mb-4">Kontakt</h1>
      <p className="text-muted-foreground">Inhalt folgt in Kürze.</p>
    </main>
    <Footer />
  </>
);

export default Kontakt;
